/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/NyhetPage/CHANGE_USERNAME';
export const TO_LIST = 'boilerplate/NyhetPage/TO_LIST';
export const TO_MASONRY = 'boilerplate/NyhetPage/TO_MASONRY';
export const CHANGE_PAGE = 'boilerplate/NyhetPage/CHANGE_PAGE';
export const CHANGE_MORE = 'boilerplate/NyhetPage/CHANGE_MORE';
export const CHANGE_PAGESIZE = 'boilerplate/NyhetPage/CHANGE_PAGESIZE';

